import { render, staticRenderFns } from "./register-account-form.vue?vue&type=template&id=b0950c8c"
import script from "./register-account-form.vue?vue&type=script&lang=js"
export * from "./register-account-form.vue?vue&type=script&lang=js"
import style0 from "./register-account-form.vue?vue&type=style&index=0&id=b0950c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports